import { render, staticRenderFns } from "./ButtonFill.component.vue?vue&type=template&id=1256e71e&"
import script from "./ButtonFill.component.vue?vue&type=script&lang=js&"
export * from "./ButtonFill.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports